import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { CheckAvailabilityContext } from '../CheckAvailabilityContext';
import '../styles/check-availability.scss';
import { ZipInputMobileDrawer } from './ZipInputMobileDrawer';
import { ZipInputModal } from './ZipInputModal';
import { InputForm } from './subcomponents/inputForm/InputForm';

export const ShippingService = () => {
  const {
    onSubmitForm,
    showLoader,
    quantity,
    onError,
    storeId,
    itemId,
    price,
    zip,
    showCheckAvailability,
    setShowCheckAvailability,
    useDrawerModal,
  } = useContext(CheckAvailabilityContext);

  const { channel } = useContext(ExperienceContext);

  const [getShipping, { data, loading, error }] = useDataModel('shipping', {
    variables: {
      itemId,
      storeId,
      zipCode: zip,
      quantity,
      price
    },
    fetchPolicy: 'no-cache'
  }, true);

  const onSubmit = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }
    getShipping();
  }, []);

  const [errorMessage, updateErrorMessage] = useState(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(showCheckAvailability);

  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
    if (error) {
      let errorMessageToDisplay = error.message;
      if (error.message.search(/zipCode does not exist/i) > -1) {
        errorMessageToDisplay = 'Please enter a valid ZIP Code.';
      }
      updateErrorMessage(errorMessageToDisplay);
    } else if (data && onSubmitForm) {
      onSubmitForm(data);
      updateErrorMessage(null);

      // closes the ZipInputMobileDrawer
      if (channel === 'mobile' && useDrawerModal) {
        setIsQuickViewOpen(false);
      }
    }
  }, [data, error, loading]);

  if (loading && showLoader && !useDrawerModal) {
    return (
      <span className="segment-spinner segment-spinner--small" />
    );
  }

  return (
    <div>
      {(channel === 'desktop' && useDrawerModal)
        && (
          <ZipInputModal
            errorMessage={errorMessage}
            onSubmit={onSubmit}
            overlay={showCheckAvailability}
            setOverlay={setShowCheckAvailability}
          />
        )}

      {(channel === 'mobile' && useDrawerModal)
        && (
          <ZipInputMobileDrawer
            isQuickViewOpen={showCheckAvailability}
            setIsQuickViewOpen={setShowCheckAvailability}
            errorMessage={errorMessage}
            onSubmit={onSubmit}
          />
        )}

      {!useDrawerModal
        && (
          <div className="check-availability">
            <InputForm onSubmit={onSubmit} errorMessage={errorMessage} />
          </div>
        )}
    </div>
  );
};
